var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurkey = function SvgTurkey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#turkey_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m13.426 11.44 1.149 1.583 1.86-.603L15.285 14l1.148 1.583-1.86-.605-1.15 1.581.001-1.956-1.86-.605 1.86-.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.292 17.957a3.957 3.957 0 1 1 1.882-7.438 4.87 4.87 0 1 0 0 6.962c-.56.303-1.201.476-1.882.476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "turkey_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgTurkey;